import moment from 'moment-timezone'

export const formatDate = date => {
  if (!date) return null
  return moment(date).format('DD.MM.YYYY')
}

export const parseDate = date => {
  if (!date) return null
  return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD')
}

export const scrollDatePickerYears = date => {
  setTimeout(() => {
    if (!date && document.querySelector('.menuable__content__active .v-date-picker-years')) {
      document.querySelector('.menuable__content__active .v-date-picker-years').scrollTop = 5000
    }
    return false
  }, 100)
}

export const formData = item => {
  const body = new FormData()
  body.append('type_file', item.type)

  item.files.forEach(file => {
    body.append('files', file)
  })

  return body
}
